<template>
  <section class="hero is-default is-bold">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-8 is-offset-2">
            <my-notification :icon="'info'">
              <template #title>
                {{ $t('viewPurchasesSimulator.title') }}
              </template>
              <span v-html="$t('viewPurchasesSimulator.info')" />
            </my-notification>
            <br />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PurchasesSimulator',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  }
}
</script>
